module.exports = function(q) {

    console.log(q);

    this.pagination.activePage = 1;
    //this.searchQuery = q;

    this.getData();


}